import {
  InsuranceMonitor,
  InsuranceMonitorJobStatus
} from "@wingspanhq/wingspan-api-sdk";
import groupBy from "lodash/groupBy";

/**
 * Whether the monitor's coverage satisfies the requirement in full.
 *
 * An either/or requirement (several accepted policy types on the same monitor,
 * e.g. Workers' Compensation OR Occupational Accident) is satisfied as soon as
 * ONE accepted policy type's checks all pass — it is not required that every
 * accepted alternative pass. `InsuranceMonitor.jobs` carries one check per
 * required policy type, so grouping by `policyType` reproduces those groups.
 *
 * Ported from wingspan-app@22dda2e98, which grouped the checks it re-derived in
 * the browser from the monitor's inline settings. v3 reads the server's own
 * results instead (see getInsuranceMonitorValidationItems), so no accepted
 * coverage config is re-validated here.
 *
 * `jobs` is empty until matching has run, which is not a full match.
 */
export const selectorIsFullMatch = (monitor: InsuranceMonitor): boolean => {
  const jobs = monitor.jobs ?? [];

  if (jobs.length === 0) {
    return false;
  }

  const jobsByPolicyType = groupBy(jobs, job => job.policyType ?? "");

  return Object.values(jobsByPolicyType).some(policyTypeJobs =>
    policyTypeJobs.every(
      job => job.status === InsuranceMonitorJobStatus.COMPLETE
    )
  );
};
